module.exports = __webpack_public_path__ + "img/kariyer_net_logo-white@2x.0aca4086.svg";